module.exports = __webpack_public_path__ + "img/hzm-back.733bda8c.png";